export default "__VITE_ASSET__C2DiH7Lk__"